import { render, staticRenderFns } from "./BrokerInformation.vue?vue&type=template&id=261c7c90&scoped=true&"
import script from "./BrokerInformation.vue?vue&type=script&lang=js&"
export * from "./BrokerInformation.vue?vue&type=script&lang=js&"
import style0 from "./BrokerInformation.vue?vue&type=style&index=0&id=261c7c90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c7c90",
  null
  
)

export default component.exports